import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./styles/App.css";
import { isAuthenticated } from "./services/authService";

import LoginPage from "./pages/LoginPage";
import ProtectedRoute, { PermissionRoute } from "./components/ProctedRoute";
import Dashboard from "./pages/Dashboard";
import IncomingCalls from "./pages/IncomingCalls";
import UserManagement from "./pages/UserManagement";
import NidVerify from "./pages/NidVerify";
import UserBalance from "./pages/UserBalance";
import Header from "./components/Header";
import SideBar from "./components/SideBar";
import RechargeHistory from "./pages/RechargeHistory";
import UserAccount from "./pages/UserAccount";
import SipTrunks from "./pages/SipTrunks";
import UserSessions from "./pages/UserSessions";
import RateSheets from "./pages/RateSheets";
import Stickers from "./pages/Stickers";
import ChatReports from "./pages/ChatReports";
import AccountDeletionRequests from "./pages/AccountDeletionRequests";
import ServiceNumbers from "./pages/ServiceNumbers";

function AppLayout({ children }) {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const handleSidebarToggle = (isOpen) => setIsSidebarOpen(isOpen);

  const isLoginPage = location.pathname === "/login";

  return (
    <div className={`app-wrapper ${!isLoginPage && isSidebarOpen ? "sidebar-open" : ""}`}>
      {!isLoginPage && <SideBar onToggle={handleSidebarToggle} />}
      <div className="app-container">
        {!isLoginPage && <Header />}
        {children}
      </div>
    </div>
  );
}

function App() {
  const [authed, setAuthed] = useState(isAuthenticated());

  useEffect(() => {
    const onStorage = () => setAuthed(isAuthenticated());
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return (
    <Router>
      <AppLayout>
        <Routes>
          <Route
            path="/login"
            element={
              authed ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <LoginPage onLoginSuccess={() => setAuthed(true)} />
              )
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="call_logs" action="view">
                  <Dashboard />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/incoming-calls"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="call_logs" action="view">
                  <IncomingCalls />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/nid-verification"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="nid_verifications" action="view">
                  <NidVerify />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          {/* <Route
            path="/user-balance"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="user_balance" action="view">
                  <UserBalance />
                </PermissionRoute>
              </ProtectedRoute>
            }
          /> */}

          {/* New Routes */}
          <Route
            path="/recharge-history"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="recharge_history" action="view">
                  <RechargeHistory />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-account"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="user_account" action="view">
                  <UserAccount />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/sip-trunks"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="sip_trunks" action="view">
                  <SipTrunks />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-sessions"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="user_sessions" action="view">
                  <UserSessions />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/rate-sheets"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="rate_sheets" action="view">
                  <RateSheets />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/stickers"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="stickers" action="view">
                  <Stickers />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/chat-reports"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="chat_reports" action="view">
                  <ChatReports />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/account-deletion-requests"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="account_deletion_requests" action="view">
                  <AccountDeletionRequests />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/service-numbers"
            element={
              <ProtectedRoute>
                <PermissionRoute resource="service_numbers" action="view">
                  <ServiceNumbers />
                </PermissionRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/"
            element={<Navigate to={authed ? "/dashboard" : "/login"} replace />}
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppLayout>
    </Router>
  );
}

export default App;
